import React, { useState, useEffect } from "react";
import { Button, Box, Text, Image } from "@chakra-ui/react";

const VerifyUser: React.FC = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [messageType, setMessageType] = useState<"success" | "error" | null>(null);

  useEffect(() => {
    // Function to get URL parameters
    const getParameterByName = (name: string, url?: string) => {
      if (!url) url = window.location.href;
      // eslint-disable-next-line
      name = name.replace(/[\[\]]/g, "\\$&");
      const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    // Get token from URL parameter
    const tokenFromURLParams = getParameterByName("token");

    if (tokenFromURLParams) {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const query = `
        mutation($input: VerifyEmailInput!) {
          verifyEmail(input: $input) {
            success
          }
        }
      `;
      const variables = { input: { token: tokenFromURLParams } };

      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query, variables }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.errors && data.errors.length) {
            const errorMessage = data.errors[0].message || "Something went wrong";
            if (errorMessage.includes("already verified")) {
              setMessage("Your account has already been verified! Please log in.");
              setMessageType("success");
            } else {
              setMessage("We regret to inform you that we encountered an issue while attempting to verify your account. Please contact Family Doctor support for assistance1.");
              setMessageType("error");
              console.log(data);
            }
          } else if (data.data?.verifyEmail?.success) {
            setMessage("Your account has been successfully verified! Please log in.");
            setMessageType("success");
          } else {
            setMessage("We regret to inform you that we encountered an issue while attempting to verify your account. Please contact Family Doctor support for assistance2.");
            setMessageType("error");
          }
        })
        .catch(() => {
          setMessage("An unexpected error occurred. Please try again later.");
          setMessageType("error");
        });
    } else {
      setMessage("Verification token not found in the URL.");
      setMessageType("error");
    }
  }, []);

  const handleButtonClick = () => {
    window.close();
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bg="#F7F9FC"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        bg="#FFFFFF"
        border="1px solid #E2E8F0"
        borderRadius="8px"
        boxShadow="md"
        p="40px"
        maxWidth="400px"
        width="100%"
        mx="16px"
      >
        <Image
          src="/logo.jpg" 
          alt="Family Doctor Logo"
          mb={4}
          width="120px"
        />

        <Text fontSize="lg" fontWeight="bold" textAlign="center" mb={4}>
          Verify Your Account
        </Text>

        {message && (
          <Text
            fontSize="md"
            textAlign="center"
            mb={4}
            color={messageType === "success" ? "green.500" : "red.500"}
          >
            {message}
          </Text>
        )}

        <Button
          bg="#B92F2F"
          color="#fff"
          mt={4}
          width="100%"
          borderRadius="24px"
          py={6}
          fontSize="sm"
          _hover={{ bg: "#9a2727" }}
          onClick={handleButtonClick}
        >
          Done
        </Button>
      </Box>
    </Box>
  );
};

export default VerifyUser;
